import { PublicClientApplication, BrowserCacheLocation } from '@azure/msal-browser';
import { logger } from '../services/logger/logger';

const clientId = process.env.REACT_APP_AZURE_CLIENT_ID;
const tenantId = process.env.REACT_APP_AZURE_TENANT_ID;
const redirectUri = process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin;
const postLogoutRedirectUri =
  process.env.REACT_APP_AZURE_POST_LOGOUT_REDIRECT_URI || `${window.location.origin}/login`;

if (!clientId || !tenantId) {
  throw new Error(
    'Missing Azure AD config: set REACT_APP_AZURE_CLIENT_ID and REACT_APP_AZURE_TENANT_ID in .env',
  );
}

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}/v2.0`,
    redirectUri,
    postLogoutRedirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: true, // Set to true for IE11 or Edge legacy support
    secureCookies: process.env.NODE_ENV === 'production',
  },
};

export const azureApiScope = process.env.REACT_APP_AZURE_API_SCOPE || '';
if (!azureApiScope) {
  logger.warn('REACT_APP_AZURE_API_SCOPE is not set; API token acquisition may fail.');
}

export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL instance
msalInstance.initialize().then(() => {
  // Handle redirect promise on page load
  msalInstance.handleRedirectPromise().catch((error) => {
    logger.error('Failed to handle redirect', error as Error);
  });
});
